import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkComponent } from './link.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ LinkComponent ],
    declarations: [ LinkComponent ],
})
export class LinkModule { }
